import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/[locale]/offers/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Antonie/Components/animated-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferCard"] */ "/app/src/components/OfferCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/app/src/Header/Component.client.tsx");
